import React from 'react'

export const Page404 = () => {
  return (
    <div>404</div>
  )
}
